import { composer } from '../../component-decorators/composer';
import * as React from 'react';
import { ManageInstalledApps, Origin } from '@wix/manage-installed-apps';
import { config } from '../../config';
import { Path } from '../..';
import { useConfigContext } from '../../config-context';
import type { IManageAppsDeepLinkData } from '../../types/common/marketplace';
import { getReferralInfo } from '../../common/bi-events';
import type { MarketplaceStore } from '../../component-decorators/with-marketplace-store';

export interface IManageAppsProps {
  marketplaceStore?: MarketplaceStore;
  manageAppsDeepLinkData?: IManageAppsDeepLinkData;
}

export const ManageApps = composer()
  .withMarketplaceStore()
  .compose(({ marketplaceStore, manageAppsDeepLinkData }: IManageAppsProps) => {
    const {
      locale,
      finishAppInstall,
      getAppInstance,
      showUserActionNotification,
      unInstallApp,
      openApp,
      countryCode,
    } = useConfigContext();
    return (
      <>
        <ManageInstalledApps
          locale={locale}
          metasiteId={marketplaceStore.metaSiteId}
          baseUrl={config.baseApiUrl}
          origin={Origin.EDITOR}
          editorUrl={config.editorUrl}
          manageAppsStaticsUrl={config.manageAppsStaticsUrl}
          mainButtonAction={config.manageAppsMainButtonAction}
          getAppInstance={getAppInstance}
          addAppAgain={finishAppInstall}
          goToHomePage={() =>
            config.goto({ path: Path.HOME, referral: 'manage-apps' })
          }
          gotoWebSolutionPage={(
            slug: string,
            referrer: string,
            impressionid?: string,
            referralSectionName?: string,
          ) =>
            config.goto({
              path: Path.WEB_SOLUTION,
              slug,
              referral: referrer,
              collimp_id: impressionid,
              referralSectionName,
            })
          }
          editorType={config.editorType}
          showUserActionNotification={showUserActionNotification}
          referralInfo={getReferralInfo(
            marketplaceStore.route && marketplaceStore.route.referral,
          )}
          unInstallApp={unInstallApp}
          openApp={openApp}
          deepLinkData={{
            appId: manageAppsDeepLinkData && manageAppsDeepLinkData.appId,
            modal: manageAppsDeepLinkData && manageAppsDeepLinkData.modal,
          }}
          hideBusinessSolutions={
            marketplaceStore.hideBusinessSolutionsInManageApps
          }
          geo={countryCode}
        />
      </>
    );
  });
